<template>
  <v-dialog
    v-model="dialogOpen"
    v-if="dialogOpen"
    content-class="my-custom-dialog"
    transition="dialog-top-transition"
    persistent
    scrollable
    max-width="60%"
    @keydown.esc="close"
  >
    <v-card class="glass-card">
      <v-card-title class="glass-header">
        <h2 class="gradient-text">{{ $t("$vuetify.tables.tables") }}</h2>
        <v-spacer></v-spacer>
        <v-switch
          v-model="switchDeleteMode"
          :disabled="switchDisabled"
          label="Obriši stolove"
          color="white"
          class="delete-switch"
        ></v-switch>
        <v-btn class="create-button mr-2" @click="addTable">
          <v-icon small class="mr-2">mdi-plus</v-icon>
          {{ $t("$vuetify.tables.create") }}
        </v-btn>
        <v-btn class="close-button" @click="close">
          <v-icon small class="mr-2">mdi-check</v-icon>
          {{ $t("$vuetify.tables.close") }}
        </v-btn>
      </v-card-title>
      <v-card-text class="glass-body">
        <v-container class="panel-container">
          <v-row>
            <v-col
              v-for="(table, idxc) in emptyTables"
              :key="idxc"
              :cols="3"
              class="panel-cell"
              align="center"
            >
              <v-btn
                v-longpress:[table]="renameTable"
                :disabled="tableLocked(table)"
                block
                depressed
                elevation="0"
                min-height="6rem"
                return-object
                class="table-btn"
                @click="onCellClick(table)"
              >
                <span class="white--text tile btn-lg">{{ table.name }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog v-model="tableRename" max-width="500">
      <v-card class="glass-card-rename">
        <v-card-title class="glass-header-rename">
          <h2 class="gradient-text-rename">Preimenuj stol</h2>
        </v-card-title>
        <v-card-text class="glass-body-rename">
          <v-text-field
            v-model="newTableName"
            label="Naziv stola"
            placeholder="Unesite novi naziv"
            dense
            outlined
            hide-details="auto"
            class="filter-select"
            autofocus
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="glass-actions-rename">
          <v-spacer></v-spacer>
          <v-btn class="soft-button" @click="updateTableName()">
            <v-icon small class="mr-2">mdi-check</v-icon>
            Spremi
          </v-btn>
          <v-btn class="cancel-button" @click="tableRename = false">
            <v-icon small class="mr-2">mdi-close</v-icon>
            Otkaži
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <add-new-table-dialog
      v-if="addTableDialogOpen"
      :table="table"
      :tables="availableTables"
      @closeAddTableDialog="onCloseAddTableDialog"
      @addTable="finishAddTable"
    ></add-new-table-dialog>
  </v-dialog>
</template>

<script>
import AddNewTableDialog from '@/modules/cash-register/components/dialogs/AddNewTableDialog.vue'
import state from '@/state'
import { df } from '@/plugins/firebase'

export default {
  components: {
    AddNewTableDialog
  },
  inject: ['confirm', 'confirmClose'],
  data () {
    return {
      dialogOpen: true,
      tables: [],
      persist: true,
      addTableDialogOpen: false,
      table: {},
      currentTableNumber: 0,
      switchDeleteMode: false,
      switchDisabled: true,
      emptyTables: [],
      tableForRename: undefined,
      newTableName: '',
      tableRename: false
    }
  },
  props: {
    availableTables: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    availableTables: {
      immediate: true,
      deep: true,
      handler (newValue, _) {
        if (newValue.length === 0) {
          this.switchDeleteMode = false
          this.switchDisabled = true
        } else {
          this.switchDisabled = false
        }

        this.emptyTables = newValue.filter((table) =>
          !table.items || table.items.length === 0
        )
      }
    }
  },
  mounted () {
    this.emptyTables = this.availableTables.filter((table) =>
      !table.items || table.items.length === 0
    )
  },
  methods: {
    renameTable (table) {
      this.tableForRename = table
      this.newTableName = table.name
      this.tableRename = true
    },
    updateTableName () {
      var tb = this.tableForRename
      var newName = this.newTableName

      this.tableRename = false
      this.tableForRename = undefined
      this.newTableName = ''

      if (this.emptyTables && this.emptyTables.length > 0) {
        this.emptyTables.forEach((tbl, key) => {
          if (tbl.id === tb.id) {
            this.emptyTables[key].name = newName
          }
        })
      }

      this.updateTableNameInDb(tb.id, newName)
      this.$forceUpdate()
    },
    updateTableNameInDb (tableId, newName) {
      df.doc(`location_orders/${state.getPointOfSale().id}/tables/${tableId}`).update({
        name: newName
      })
        .then(() => {
          console.info('Table succesfully updated.')
        })
        .catch(() => {
          console.error('Table has not been updated succesfully.')
        })
    },
    tableLocked (table) {
      return table.locked && table.locked_by !== state.getUser().id
    },
    close () {
      this.$emit('closeTablesDialog')
    },
    onCloseAddTableDialog () {
      this.addTableDialogOpen = false
    },
    addTable () {
      this.getCurrentTableNumber(true)
    },
    finishAddTable (table, persist) {
      table.persistent = persist
      this.addTableDialogOpen = false
      try {
        this.availableTables.push(table)
        this.saveTable(table, persist)
      } catch (err) {
        console.error('Error saving table: ', err)
      }
    },
    async saveTable (table, persist) {
      this.$emit('saveTable', table, persist, true)
    },
    onCellClick (table) {
      if (!this.switchDeleteMode) {
        this.$emit('addTable', table)
        this.$emit('closeTablesDialog')
      } else {
        this.deleteTable(table)
      }
    },
    deleteTable (table) {
      this.confirm({
        title: 'Brisanje stola',
        message: `${this.$t('$vuetify.tables.delete')} ${table.name}?`,
        options: {
          toolbar: true,
          width: 410,
          confirmText: this.$t('$vuetify.yes'),
          cancelText: this.$t('$vuetify.no')
        }
      }).then(async (resp) => {
        if (resp) {
          this.$emit('deleteTable', table)
        }
        this.confirmClose()
      })
    },
    getCurrentTableNumber (openDialog = false) {
      const query = df.collection(`location_orders/${state.getPointOfSale().id}/tables`).orderBy('number', 'desc').limit(1)
      query.get()
        .then((documentSnapshots) => {
          if (documentSnapshots.docs && !documentSnapshots.docs.empty && documentSnapshots.docs.length > 0) {
            documentSnapshots.docs.forEach((item) => {
              this.currentTableNumber = item.data().number

              if (openDialog === true) {
                const number = this.currentTableNumber + 1
                const name = `Stol ${number}`
                this.table = { name: `${name}`, number: number, items: [], persistent: true, color: 'primary' }
                this.addTableDialogOpen = true
              }
            })
          } else {
            this.currentTableNumber = 0
            if (openDialog === true) {
              const number = this.currentTableNumber + 1
              const name = `Stol ${number}`
              this.table = { name: `${name}`, number: number, items: [], persistent: true, color: 'primary' }
              this.addTableDialogOpen = true
            }
          }
        })
      /*
      if (this.availableTables.length === 0) {
        this.currentTableNumber = 0
      } else {
        this.currentTableNumber = Math.max(...this.availableTables.map(table => table.number))
      } */
    }
  },
  created () {
    this.getCurrentTableNumber()
  }
}
</script>

<style scoped>
.v-dialog__content >>> .my-custom-dialog {
  position: absolute;
  top: 50px;
  border-radius: 16px;
}

/* Glass Card Style - Main Modal */
.glass-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.1) !important;
  overflow: hidden;
}

/* Glass Header with Gradient */
.glass-header {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
  padding: 20px 24px !important;
  position: relative;
  display: flex;
  align-items: center;
}

/* Gradient Text for Title */
.gradient-text {
  font-size: 24px !important;
  font-weight: 600 !important;
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.95) 50%,
    rgba(255, 255, 255, 1) 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  letter-spacing: 0.5px !important;
  display: inline-block !important;
}

/* Glass Body */
.glass-body {
  background: transparent !important;
  padding: 24px 16px !important;
}

/* Delete Switch Style */
.delete-switch {
  margin-right: 16px !important;
  margin-top: 0 !important;
}

.delete-switch >>> .v-input__slot {
  margin-bottom: 0 !important;
}

.delete-switch >>> .v-label {
  color: white !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
}

.delete-switch >>> .v-input--selection-controls__ripple {
  color: white !important;
}

/* Create Button Style */
.create-button {
  background: rgba(255, 255, 255, 0.95) !important;
  color: #3989C9 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 2px 8px rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 20px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.create-button:hover {
  background: rgba(255, 255, 255, 1) !important;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3) !important;
  transform: translateY(-1px);
}

.create-button .v-icon {
  color: #3989C9 !important;
}

/* Close Button Style */
.close-button {
  background: rgba(255, 255, 255, 0.95) !important;
  color: #3989C9 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 2px 8px rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 20px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.close-button:hover {
  background: rgba(255, 255, 255, 1) !important;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3) !important;
  transform: translateY(-1px);
}

.close-button .v-icon {
  color: #3989C9 !important;
}

.panel-container {
  margin-top: 0;
}

.panel-cell {
  padding: 8px;
}

/* Table Button Style */
.table-btn {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.9) 0%,
    rgba(57, 137, 201, 0.85) 50%,
    rgba(97, 84, 164, 0.9) 100%) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(0, 179, 190, 0.25) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.table-btn:hover:not(:disabled) {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 0.95) 50%,
    rgba(97, 84, 164, 1) 100%) !important;
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 20px rgba(0, 179, 190, 0.4) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.table-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  background: rgba(120, 120, 130, 0.5) !important;
}

.btn-lg {
  font-size: 1.4rem;
  font-weight: 700;
  display: block;
  white-space: normal;
  word-break: break-word;
}

/* Rename Dialog Styles */
.glass-card-rename {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.1) !important;
  overflow: hidden;
}

.glass-header-rename {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
  padding: 24px 16px !important;
  position: relative;
}

.gradient-text-rename {
  font-size: 20px !important;
  font-weight: 600 !important;
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.95) 50%,
    rgba(255, 255, 255, 1) 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  letter-spacing: 0.5px !important;
  display: inline-block !important;
}

.glass-body-rename {
  background: transparent !important;
  padding: 24px 16px !important;
}

.glass-actions-rename {
  background: transparent !important;
  padding: 16px 24px 24px !important;
}

/* Filter Select Input */
.filter-select.v-text-field--outlined >>> fieldset {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.filter-select >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  min-height: 40px !important;
  border-radius: 8px !important;
}

.filter-select >>> .v-text-field__slot input {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
}

.filter-select >>> label {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(57, 137, 201, 0.8) !important;
}

/* Soft Button Style (Primary) */
.soft-button {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #3989C9 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.15) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  margin-left: 8px !important;
}

.soft-button:hover {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  border-color: rgba(57, 137, 201, 0.3) !important;
  transform: translateY(-1px);
}

.soft-button .v-icon {
  font-size: 18px !important;
  color: #3989C9 !important;
}

/* Cancel Button Style */
.cancel-button {
  background: rgba(245, 245, 245, 0.8) !important;
  color: rgba(70, 70, 80, 0.9) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(120, 120, 130, 0.15) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  margin-left: 8px !important;
}

.cancel-button:hover {
  background: rgba(230, 230, 230, 0.9) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12) !important;
  border-color: rgba(120, 120, 130, 0.25) !important;
  transform: translateY(-1px);
}

.cancel-button .v-icon {
  font-size: 18px !important;
  color: rgba(70, 70, 80, 0.9) !important;
}
</style>
